import { render, staticRenderFns } from "./LivingOptionProperties.vue?vue&type=template&id=356b1a5d&scoped=true"
import script from "./LivingOptionProperties.vue?vue&type=script&lang=js"
export * from "./LivingOptionProperties.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionProperties.vue?vue&type=style&index=0&id=356b1a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b1a5d",
  null
  
)

export default component.exports